module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1319/plan4-2-dd3b887c2c2a8d49502abb62e03a3ebe.webp";